<script lang="ts" setup>
import { ref } from 'vue'
import ChannelSettingsIndex from './ChannelSettingsIndex.vue'
import { app } from '@/composition/app'
import ChannelListMobile from './mobile/ChannelListMobile.vue'
import ChannelListWeb from './web/ChannelListWeb.vue'
import { useRouter } from 'vue-router'

defineProps({
  isLoading: Boolean,
})

const router = useRouter()
const showChannelSettingsModal = ref(false)

const settingModalType = ref<'update' | 'create'>('update')

const emit = defineEmits([
  'channel-changed',
  'close-sidenav',
  'open-modal-flag',
  'show-add-channel-modal',
])

function openChannelSetting() {
  settingModalType.value = 'update'
  showChannelSettingsModal.value = true
}

async function addChannel() {
  settingModalType.value = 'create'
  showChannelSettingsModal.value = true
}

function closeChannelSettings() {
  showChannelSettingsModal.value = false
}

async function changeChannel(slug: string) {
  emit('channel-changed')
  router.push({
    name: 'channel-overview',
    params: {
      channelSlug: slug,
    },
  })
}
</script>
<template>
  <div class="w-full">
    <ChannelListWeb
      v-if="!app.state.isMobile"
      @channel-changed="changeChannel($event)"
      @open-modal-flag="openChannelSetting"
      @show-add-channel-modal="addChannel"
    />
    <ChannelListMobile
      v-else
      :is-loading="isLoading"
      @channel-changed="emit('channel-changed')"
      @close-sidenav="emit('close-sidenav')"
      @open-modal-flag="emit('open-modal-flag')"
      @show-add-channel-modal="emit('show-add-channel-modal')"
    />
    <!-- for editing a channel  -->
    <ChannelSettingsIndex
      v-if="showChannelSettingsModal"
      :type="settingModalType"
      :show="showChannelSettingsModal"
      @update:show="showChannelSettingsModal = false"
      @update:confirmed="closeChannelSettings"
    />
  </div>
</template>

<style scoped>
.radio-style {
  width: 200px;
  max-width: 300px;
}

#radio-style:checked {
  background-color: #3b82f6;
}

.channel-list-scrollbar {
  scrollbar-width: thin;
}

.revert-box-sizing {
  box-sizing: revert !important;
}
.n-divider:not(.n-divider--vertical) {
  margin-top: 10px;
  margin-bottom: 10px;
}
@media (max-width: 930px) {
  .channel-list {
    height: 100% !important;
  }
}
</style>
